import { updateGetters } from '@/store/extensions/update';
import { fetchGetters } from '@/store/extensions/fetch';

export default {
  ...updateGetters,
  ...fetchGetters,

  reverting: state => state.reverting,
  context: state => state.context,
  diffModalOpened: state => state.diffModalOpened,
  diffModalAdditionalContext: state => state.diffModalAdditionalContext,

  versionFromContext: (state, getters) => (
    state.context ? getters.find(state.context) : null
  ),
};



// WEBPACK FOOTER //
// ./src/store/modules/version/getters.js